export default __webpack_public_path__ + "static/media/playagain_btn.490a13bf.png";